<template>
  <v-autocomplete
    label="Profile"
    v-model="selected"
    @input="handleInput"
    :search-input.sync="searchTerm"
    :placeholder="searchTerm"
    :disabled="disabled"
    :rules="rules || []"
    :required="required"
    :loading="loading"
    :items="options"
    :hint="hint"
    item-value="id"
    return-object
    hide-no-data
    no-filter
    clearable
  >
    <template slot="item" slot-scope="{ item: profile }">
      <v-list-tile-avatar>
        <img :src="profile.avatar || '/img/missing/avatars/original.png'" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>
          {{ `${profile.firstNames} ${profile.lastName}` }}
        </v-list-tile-title>
        <v-list-tile-sub-title>
          {{ profile.candidate ? profile.candidate.email : profile.identification }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>

    <template slot="selection" slot-scope="{ item: profile }">
      <v-chip>
        <v-avatar>
          <img :src="profile.avatar || '/img/missing/avatars/original.png'" />
        </v-avatar>
        {{ `${profile.firstNames} ${profile.lastName}` }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapGetters } from 'vuex'

// Vue Component
export default {
  created() {
    if (_.get(this.value, 'id')) {
      this.$http.get(`admin/profiles/${this.value.id}`).then(response => {
        this.cached.push(response.data)
        this.profiles.push(response.data)
        this.selected = response.data
      })
    } else if (Number.isInteger(this.value)) {
      this.$http.get(`admin/profiles/${this.value}`).then(response => {
        this.cached.push(response.data)
        this.profiles.push(response.data)
        this.selected = response.data
      })
    }
  },

  props: {
    value: [Object, Number],
    rules: Array,
    required: Boolean,
    disabled: Boolean,
    hint: { type: String, default: () => 'Search Profiles' },
  },

  data() {
    return {
      selected: {},
      loading: false,
      searchTerm: '',
      profiles: [],
      cached: [],
    }
  },

  computed: {
    options() {
      let options = this.profiles

      if (this.cached[0]) options = [...this.cached, ...this.profiles]
      return _.orderBy(options, 'fullName', 'asc')
    },
  },

  watch: {
    searchTerm: _.debounce(function(search) {
      // search is null on initial load
      if (search && search.length > 2) {
        this.search()
      }
    }, 500),
  },

  methods: {
    handleInput(profile) {
      if (!_.get(profile, 'id')) return (this.selected = null)

      if (!this.cached.some(c => c.id === profile.id)) this.cached.push(profile)
      this.$emit('input', profile.id)
      this.selected = profile
    },

    search() {
      this.loading = true
      this.$http
        .get(`admin/profiles?search=${this.searchTerm}`)
        .then(({ data }) => {
          this.profiles = _.orderBy(data.items, 'fullName', 'asc')
        })
        .catch(error => {})
        .finally(() => (this.loading = false))
    },
  },
}
</script>
